import Parse from 'html-react-parser';

function BMP20157(props) {
    let svgCode =
    `<svg width="44" height="228" viewBox="0 0 44 228" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="2" width="40" height="34" fill="${props.darkFill}"/>
        <path d="M30 24L22 17L14 24M22 17L14 24" stroke="${props.highlightColour}" stroke-width="5"/>
        <rect width="40" height="34" transform="matrix(1 0 0 -1 2 226)" fill="${props.darkFill}"/>
        <path d="M30 206L22 213L14 206M22 213L14 206" stroke="${props.highlightColour}" stroke-width="5"/>
    </svg>`

    props.svgReturn(52, svgCode, "bmp00157", 44, 228);

    const style = {
        display: props.display
    }

    return (
        <div style={style}>
            {Parse(svgCode)}
        </div>
    );
}

export default BMP20157;